import goodDlg from './goodDlg.js' // 商品dlg
import myDemandDlg from './myDemandDlg.js' // 我的需求单dlg
import myGoodDlg from './myGoodDlg.js' // 我的物资dlg
import myUserDlg from './myUserDlg.js' // 发放员工dlg
import goodTypeDlg from './goodTypeDlg.js'  // 商品分类dlg
import bzszbgGoodDlg from './bzszbgGoodDlg.js'  // 标准数值变更商品dlg

const supplyChainMan = {
  namespaced: true,
  modules: {
    goodDlg,
    myDemandDlg,
    myGoodDlg,
    myUserDlg,
    bzszbgGoodDlg,
    goodTypeDlg
  }
}

export default supplyChainMan
